import { useSelector, useDispatch } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";
import IssuesDetectedModal from "./IssuesDetectedModal.jsx";
import { closeIssuesDetectedModal } from "../../redux/issuesDetectedModalSlice.js";
import { openDocumentPreviewModal } from "../../redux/documentPreviewModalSlice.js";
import { formatTopicKey } from "../../utils/policyFormatters.js";

// Single shared instance of IssuesDetectedModal, rendered once at the layout root (see
// layouts/ContentLayout.jsx) so it stays mounted across route changes. Policy scoring can
// finish — and dispatch openIssuesDetectedModal — while the user is on any page; this
// component just reflects that Redux state, wherever it happens to be mounted. Gated on
// enablePolicyCategorization to match the flag's original behavior (modal only ever shown
// when the flag is on).
const GlobalIssuesDetectedModal = () => {
  const dispatch = useDispatch();
  const { enablePolicyCategorization } = useFlags();
  const { isOpen, topics } = useSelector(state => state.issuesDetectedModal);

  if (!enablePolicyCategorization || !isOpen) return null;

  return (
    <IssuesDetectedModal
      isOpen={isOpen}
      topics={topics}
      formatTopicKey={formatTopicKey}
      onClose={() => dispatch(closeIssuesDetectedModal())}
      onReviewAndUpdate={() => {
        dispatch(closeIssuesDetectedModal());
        dispatch(openDocumentPreviewModal());
      }}
    />
  );
};

export default GlobalIssuesDetectedModal;
